import { Fragment } from 'react';
import { noop } from 'shell/utils/noop';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { DocumentRegistryVisualizeCrumbs } from 'civil-status/constants/document-registry-breadcrumb';
import FormDocumentRegistry, {
  DocumentRegistryForm,
} from 'civil-status/components/document-registry/form';
import { useNavigate, useParams } from 'react-router-dom';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { DocumentRegistry } from 'shell/models/document-registry';
import { HttpResponse } from 'shell/models/http-response';
import { transformResponseDocumentRegistry } from 'civil-status/utils/transformer-document-registry';
import { __CIVIL_STATUS_API_URL__ } from 'shell/constants/environment';

const DocumentRegistryDetailPage = (): React.ReactElement => {
  const navigate = useNavigate();

  const params = useParams();

  const [register] = useHttpFetch<HttpResponse<DocumentRegistry>, DocumentRegistryForm>(
    `${__CIVIL_STATUS_API_URL__}/registro-atto/${params.id}`,
    {
      onBootstrap: true,
      transformer: transformResponseDocumentRegistry,
    }
  );

  const isLoading = register.isLoading || register.pristine || register.hasErrors;
  return (
    <Fragment>
      <Breadcrumbs items={DocumentRegistryVisualizeCrumbs} />
      {!isLoading ? (
        <FormDocumentRegistry
          title={'Dettaglio Numero Registro'}
          onOk={noop}
          onCancel={() => {
            navigate('/stato-civile/registri');
          }}
          disabled
          initialValues={register.data as DocumentRegistryForm}
        ></FormDocumentRegistry>
      ) : undefined}
    </Fragment>
  );
};

DocumentRegistryDetailPage.displayName = 'Document Registry Detail page component';

export default DocumentRegistryDetailPage;
